import { AdminNetworkScreen } from '@/screens/index'

export default function () {
  return <AdminNetworkScreen />
}
